import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAPI } from "../../api/ApiHelpers.ts";
import { RoleStatus } from "./constants.ts";
import { RootState } from "../store.ts";

export const fetchPhoneRoles = createAsyncThunk(
  "phone/fetchPhoneRoles",
  async (slug: string, { getState }) => {
    const store: RootState = getState() as RootState;
    const { currentPage, sortBy, status, pageSize, search, subcompany_id } =
      store.phone;

    let queryParams = {
      page: currentPage.toString(),
      page_size: pageSize.toString(),
      interview_state: status.toString(),
      ordering: sortBy.toString(),
      search: search ? search : "",
      subcompany_id: subcompany_id ? subcompany_id.toString() : "",
    };

    const res = await getAPI(
      `phone_interview_type_detailed`,
      slug,
      queryParams
    );
    return res.data;
  }
);

export const fetchWebRoles = createAsyncThunk(
  "web/fetchWebRoles",
  async (slug: string, { getState }) => {
    const store: RootState = getState() as RootState;
    const { currentPage, sortBy, status, pageSize, search, subcompany_id } =
      store.web;
  
    let queryParams = {
      page: currentPage.toString(),
      page_size: pageSize.toString(),
      interview_state: status.toString(),
      ordering: sortBy.toString(),
      search: search ? search : "",
      subcompany_id: subcompany_id ? subcompany_id.toString() : "",
    };
    let draftParams = {
      page: currentPage.toString(),
      page_size: pageSize.toString(),
      ordering: sortBy.toString(),
      search: search ? search : "",
      subcompany_id: subcompany_id ? subcompany_id.toString() : "",
    };

    if (status == RoleStatus.Draft) {
      const res = await getAPI(`interview_jd_list`, slug, draftParams);
      return res.data;
    } else {
      const res = await getAPI(`interview_type_detailed`, slug, queryParams);
      return res.data;
    }
  }
);
